module.exports = __webpack_public_path__ + "static/King_Sooper_pin_hover-878cc01773c2d9d4773e6e69626a63ed.png";